<template>
	<div v-if="isshow">
		<el-card class="box-card" shadow="never">
			<div slot="header" class="clearfix" v-if="maininfo_lang.title!=''">
				<span>{{maininfo_lang.title }}</span>
			</div>
			<div class="inputBox" v-if="!isdetail">
				<el-form-item
					v-if="i.ishidden == 'False'&&i.controltype!='table'"
					:class="['inputItem', i.controltype == 'textarea'? 'col24' :(layout=='0'?'col8':'co24') ]"
					:label="i.showname"
					label-width="100px"
					v-for="(i, index) in setlist"
					:key="index"
					size="mini"
				>
				<div v-if="i.controltype == 'disabled_billid' && i.ishidden == 'False'" style="display: inline-block;">
					<el-input
						:style="{ width: `${i.coltdwidth}px`}"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						:disabled="i.isedit"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					></el-input><i
					  class="el-icon-edit"
					  @click="editinput(i)"
					  style="cursor:pointer;"> 
					</i>
				</div>
				<div v-if="i.controltype == 'disabled_input' && i.ishidden == 'False'" style="display: inline-block;">
					<el-input
						:style="{ width: `${i.coltdwidth}px`}"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						:disabled="i.isedit"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					></el-input>
					<i v-if="i.inputshow"
					  class="el-icon-edit"
					  @click="editinput(i)"
					  style="cursor:pointer;"> 
					</i>
				</div>
					<el-input
						v-if="i.controltype == 'readonly_text' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						readonly
					></el-input>
					<el-input
						v-if="i.controltype == 'text' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						:disabled="i.isedit"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					></el-input>
					<el-date-picker
					     v-if="i.controltype == 'datetime' && i.ishidden == 'False'"
					     :style="{ width: `${i.coltdwidth}px` }"
					      type="date"
						  v-model="i.value"
						  :ref="i.colname"
						  :disabled="i.isedit"
						  @blur="val => checkinput(val, i)"
						  @keyup.native="val => enterinput(val, i)"
					      :placeholder="i.placeholder">
					</el-date-picker>
					<el-date-picker
					     v-if="i.controltype == 'datetime_ss' && i.ishidden == 'False'"
					     :style="{ width: `${i.coltdwidth}px` }"
					      type="datetime"
						  v-model="i.value"
						  :ref="i.colname"
						  :disabled="i.isedit"
						  @blur="val => checkinput(val, i)"
						  @keyup.native="val => enterinput(val, i)"
						  @change="val=>formatdate(val,'datetime_ss',i)"
					      :placeholder="i.placeholder">
					</el-date-picker>
					<!-- <el-input
						v-if="i.controltype == 'datetime' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						:disabled="i.isedit"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					></el-input> -->
					<el-input
						v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						type="text"
						v-model="i.value"
						:ref="i.colname"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					>
					</el-input>
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						class="input-with-search"
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					>
						<div slot="append" v-if="i.colass == 'search'&&!isdetail" @click="inputgroupsearch(i, index)">
							<span style="padding:15px"><i class="el-icon-search"></i></span>
						</div>
					</el-input>
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'readonly_text_group' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:readonly="true"
						:type="i.controltype"
						v-model="i.value"
						class="input-with-search"
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					>
						<div slot="append" v-if="i.colass == 'search'&&!isdetail" @click="inputgroupsearch(i, index)">
							<span style="padding:15px"><i class="el-icon-search"></i></span>
						</div>
					</el-input>
					<el-input
						:ref="i.colname"
						:type="i.controltype"
						v-model="i.value"
						v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					></el-input>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						filterable
						remote
						reserve-keyword
						:placeholder="i.placeholder"
						:remote-method="val => remoteMethod(val, i)"
						:loading="loading"
						v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@change="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					>
						<el-option v-for="item in i.colsource" :key="item.value" 
						:label="item.title" :value="item.value"></el-option>
					</el-select>
					<el-cascader
					v-if="i.controltype == 'picker' && i.ishidden == 'False'"
						:ref="i.colname"
						v-model="i.value"
						:show-all-levels="false"
						:placeholder="i.placeholder"
					    :options="i.colsource"
						:props="{value:'value',label:'label'}"
						:clearable="true"
					   @change="val => checkinput(val, i)"
					   @keyup.native="val => enterinput(val, i)">
					</el-cascader>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						v-if="i.controltype == 'select' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@change="val => checkinput(val, i)"
						filterable
						clearable
						@keyup.native="val => enterinput(val, i)"
						:placeholder="i.placeholder"
					>
						<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
					</el-select>
					<el-select
					  v-model="i.value" size="mini"
					  v-if="i.controltype == 'select_multiple' && i.ishidden == 'False'" 
					   multiple
					   filterable
					   :clearable="true"
					   @change="val => checkinput(val, i)"
					   :style="{ width: `${i.coltdwidth}px` }"
					   :placeholder="i.placeholder">
							<el-option v-for="item in i.colsource" :key="item.u_account" :label="item.u_account" :value="item.u_account"></el-option>
					 </el-select>
					<!-- :style="{width:`${i.coltdwidth}px`}" -->
					<el-checkbox
						v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
						:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
						:checked="i.coldefault == 1 ? true : false"
						@change="val => setcheck(val, i)"
					></el-checkbox>
		
					<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
					
					<div v-if="i.controltype == 'combox-input-180'||i.controltype == 'combox-input'" class="tiji">
						<span v-for="(tj, ti) in i.combox" :key="ti">
							<label v-if="tj.showname!=''" style="margin-left:5px;margin-right:5px">{{ tj.showname }}</label>
							<el-input type="text" v-if="tj.controltype=='text'" :style="{ width: `${tj.coltdwidth}px`}" v-model="tj.value" ></el-input>						
							<el-select v-if="tj.controltype=='select'" v-model="tj.value" :style="{ width: `${tj.coltdwidth}px`}" :clearable="true" :filterable="true" @change="val => checkinput(val, tj,i)">
							  <el-option v-for="(opt, opti) in tj.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
							</el-select>
							<span v-if="tj.controltype=='span'">{{tj.value}}</span>
						</span>
					</div>
				</el-form-item>
			
			</div>
			<div class="inputBox" v-if="isdetail">
				<el-form-item
					v-if="i.ishidden == 'False'&&i.controltype!='table'"
					:class="['inputItem', i.controltype == 'textarea'? 'col12' :(layout=='0'?'col8':'co24')]"
					:label="i.showname"
					label-width="100px"
					v-for="(i, index) in setlist"
					:key="index"
					size="mini"
				>
					<span>
						{{i.value}}
					</span>
				</el-form-item>
			</div>
		</el-card>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		classname: {
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		},
		defaulttitle:{
			type: String,
			default:''
		},
		layout:{
			type: String,
			default:'0'
		}
	},
	data() {
		return{
			setlist:[],
			syscol:'',
			loading:false,
			orderinfo:'',
			isdetail:false,
			maininfo_lang:{},
			//title:'',
			type:'',
			isshow:false,
			iscopy:0
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/maininfo.scss');
	},
	methods:{
		toarray(val){
			let lStrTemp = [];
			val.split(',').map(u=>{lStrTemp.push(u)});
			return lStrTemp;
		},
		
		init(param){
			//debugger
			if(param.syscol!=undefined)
				this.syscol=param.syscol;
			if(param.orderinfo!=undefined){
				this.orderinfo=param.orderinfo;
			}
			if(param.iscopy!=undefined)
				this.iscopy=param.iscopy;
			if(param.type!=undefined)
				this.type=param.type;
			//debugger
			if(param.isdetail!=undefined)
				this.isdetail=param.isdetail;
			this.setlist=[];
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode(this.type,this).then(res=>{
				if(res.state=='1'){
					that.maininfo_lang=that.$lang.label[that.type];
					if(that.maininfo_lang.title==undefined)
						that.maininfo_lang.title=that.defaulttitle;
				}
				that.getsetlist();
			});
		},
		getsetlist(){
			var that=this;
			//debugger
			this.$apipost.get.GetPagecolSet({syscol:this.syscol,l_mode:this.type}).then(res => {
				if(res.length>0){
					that.isshow=true;
					res.forEach(e=>{
						if(e.controltype.indexOf('disabled')>-1)
							e.isedit=true;
						else
							e.isedit=false;
					});
					var showname='';
					
					res.forEach(e=>{
						showname=e.showname.replace('/ /g','');
						if(that.maininfo_lang[showname]!=undefined)
							e.showname=that.maininfo_lang[showname];
					});
					if(that.setlist.length>0)
						that.setlist=that.setlist.concat(res);
					else
						that.setlist=res;
		
					if(that.orderinfo!=''){
						that.setinfovalue();
					}else{
						that.setlist.forEach(item => {
							if(item.value=='')
							{
								if(item.controltype=='disabled_billid')
									item.coldefault=new Date().getTime();
								item.value=item.coldefault.toString();
							}
						});
					}
				}
			});
		},
		setinfovalue(){
			var that=this;
			that.setlist.forEach(item => {
				var orderinfo=that.orderinfo[item.colkey];
				debugger
				if(orderinfo==undefined)
					orderinfo=that.orderinfo;
				if(orderinfo!=undefined){
					if(item.combox!=undefined){
						if(orderinfo.list!=undefined){
							var comboxinfo=orderinfo.list[0][item.colkey];
							if(comboxinfo!=undefined){
								item.combox.forEach(com=>{
									if(comboxinfo[com.colname]!=undefined)
										com.value=comboxinfo[com.colname];
								});
							}
							
						}else{
							item.combox.forEach(com=>{
								if(orderinfo[com.colname]!=undefined)
									com.value=orderinfo[com.colname];
							});
						}
					}
					else{
						//debugger
						item.inputshow=true;
						if(orderinfo[item.colname]!=undefined){
							if(item.controltype=='select_multiple')
								item.value=that.toarray(orderinfo[item.colname]);
							else if(item.controltype=='disabled_input')
							{
								if(that.iscopy==0)
									item.inputshow=false;
								item.value=orderinfo[item.colname];
							}
							else 
								item.value=orderinfo[item.colname];
						}
						else{
							if(orderinfo.list!=undefined)
								orderinfo=orderinfo.list[0][item.colkey];
							if(orderinfo[item.colname]!=undefined){	
								if(item.controltype=='select_multiple')
									item.value=that.toarray(orderinfo[item.colname]);
								else if(item.controltype=='disabled_input')
								{
									if(that.iscopy==0)
										item.inputshow=false;
									item.value=orderinfo[item.colname];
								}
								else 
									item.value=orderinfo[item.colname];	
							}
						}
					}
				}
				//debugger
				if(item.value=='')
				{
					if(item.controltype=='disabled_billid')
						item.coldefault=new Date().getTime();
					item.value=item.coldefault.toString();
					item.inputshow=true;
				}else{
					that.isedit=false;
				}
			});						
		},
		enterinput(event, i) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if (i.colnext == 'tablegrid'){
							if(this.$refs.cargo!=undefined)
								this.$refs.cargo[0].setgridfoucs();
							else{
								
							}
						}
						else{
							if(i.ishidden=='False'){
								this.$refs[i.colnext][0].focus();
							}
						}
					}
				} else if (event.keyCode == 37) {
					if(i.ishidden=='False'){
						if (i.colperv != '') this.$refs[i.colperv][0].focus();
					}
				}
			}
		},
		SetPerpay(){
			var perpay=0;
			this.setlist.forEach(e=>{
				if(e.colname=='perpay'&&e.value!='')
				{
					perpay=Number(e.value);
					return false;
				}
			});
			var isperpaymorefrieght=false;
			if(!isNaN(perpay)){
				this.setlist.forEach(e=>{
					if(e.colname=='other_fee'&&e.value.toString()!='')
					{
						if(perpay<=Number(e.coldefault)){
							e.value=(Number(e.coldefault)-perpay).toString();
						}else
							isperpaymorefrieght=true;
						return false;
					}
				});
			}
			if(isperpaymorefrieght){
				this.setlist.forEach(e=>{
					if(e.colname=='perpay')
						e.value=0;
					if(e.colname=='other_fee')
						e.value=e.coldefault;
				});
			}
		},
		getfocuscontrol(colindex,type){
			var col='';
			if(type=='next'){
				col=this.setlist[colindex+1].colnext;
			}
			else{
				col=this.setlist[colindex-1].colperv;
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		checkinput(event,i,item){
			var crm_c_id='';
			if(i.colevent.indexOf('getcustomer')>-1){
				//获取客户资料余额
				var source=i.colsource.filter(function(e){
					return e.title==i.value;
				});
				if(source.length>0){
					crm_c_id=source[0].id;
					this.$tool.GetCustomerInfo({id:crm_c_id},this).then(res => {
						if(res.state=='1'){
							//debugger
							if(item!=undefined){
								item.combox.forEach(b=>{
									if(b.colname!=i.colname)
									{
										b.value=res.customerinfo[i.colfun];
										return false;
									}
								});
							}
						}
					});
				}
				//获取应收/应付账单
				if(i.colevent=='getcustomerandbill')
					this.$emit('maincallback',{event:'getperbill',crm_c_id:crm_c_id});
			}
			else if(i.colevent=='perpay-fee'){
				this.SetPerpay();
			}
		},
		//下拉选项联动
		remoteMethod(val,i) {
			var that = this;
			if(i.colevent=='customer'){
				var search = {
					searchbox: val,
					c_type:i.colfun
				};
				this.$tool.customerlink(this, search, '',i);
			}
			else{
				//debugger
				if(i.colevent!=''){
					var search={};
					search.searchbox=val;
					search.searchcol=i.colass;
					this.$tool.GetSelectData(this,i.colevent,i.colfun,search).then(res => {
						//debugger
						i.colsource=res;
					});
				}
			}
		},
		formatdate(val,type,item){
			//debugger
			if(type=='datetime_ss'){
				item.value=this.$tool.datetotime_ss(val);
			}
		},
		setvalue(data,value){
			//debugger
			this.$emit('setvalue',{data:data,value:value});
		},
		//带搜索的输入框
		inputgroupsearch(i,index) {
			
		},
		editinput(i){
			i.isedit=false;
			var that=this;
			this.$nextTick(function() {
				that.$refs[i.colname][0].focus();
			});
		},
		setinputvalue(e){
			this.setlist.forEach(item=>{
				if(item.colname==e.colname){
					item.value=e.value;
					item.coldefault=e.value;
					return false;
				}
			});
		},
		setinputenable(e){
			this.setlist.forEach(item=>{
				if(item.colname==e.colname){
					//debugger
					item.isedit=e.disenabeld;
					item.value='';
					return false;
				}
			});
		}
	}
}
</script>

<style>
</style>
